export default __webpack_public_path__ + "static/media/nothing-here-icon.de9a123a.png";